const entradas_compra = state => state.entradas_compra;

export default {
  entradas_compra,
};